module.exports = __webpack_public_path__ + "static/media/hackachu.5194b0ec.jpg";